import { render, staticRenderFns } from "./GClassManagementGroupSettingModal.vue?vue&type=template&id=3f14492e&scoped=true&"
import script from "./GClassManagementGroupSettingModal.vue?vue&type=script&lang=ts&"
export * from "./GClassManagementGroupSettingModal.vue?vue&type=script&lang=ts&"
import style0 from "./GClassManagementGroupSettingModal.vue?vue&type=style&index=0&id=3f14492e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f14492e",
  null
  
)

export default component.exports